const asideMenu = {
    $item: $('.aside-list-item'),

    hovering: function () {
        let container = this.$item.parent();
        let itemsList = container.find('.aside-list-item');

        itemsList.each(function () {
            $(this).toggleClass('aside-list-item_inactive');
        });
    },

    init: function () {
        let _this = this;

        this.$item.hover(function () {

            let itemWrapper = $(this).find('.aside-list-item-wrapper');
            let subItem = $(this).find('.link_navigation_sub');

            _this.hovering();
            $(this).removeClass('aside-list-item_inactive');
            if(subItem.length > 0) {
                itemWrapper.toggleClass('aside-list-item-wrapper_active')
            }
        });
    }
};

export default asideMenu;